// extracted by mini-css-extract-plugin
export var fadeIn = "_ef-1";
export var modalContent = "_ef-3";
export var overlay = "_ef-0";
export var popoverContent = "_ef-2";
export var results = "_ef-5";
export var searchInputWrapper = "_ef-4";